import React from 'react';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import {
  Label,
  Input,
  FormFeedback,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';

const ShareModalPasswordProtect = (({
  requirePassword,
  password,
  passwordError,
  handleChangePassword,
  handleChangeRequirePassword,
}) => {
  const intl = useIntl();

  return (
    <div className="share-password-protect share-setting">
      <Label for="inpRequirePassword" className="switch">
        <span>
          {intl.formatMessage({ defaultMessage: 'Require password' })}
          <HelpIcon id="share-require-password">
            {intl.formatMessage({ defaultMessage: 'Require a password to view this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-require-password" simple={true} />
          {userHasFeature('share-require-password') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="requirePassword"
                id="inpRequirePassword"
                value={true}
                checked={requirePassword}
                onChange={handleChangeRequirePassword}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {requirePassword && (
        <>
          <Input
            type="text"
            name="password"
            id="inpPassword"
            placeholder={intl.formatMessage({ defaultMessage: 'Enter your password' })}
            invalid={passwordError}
            value={password}
            onChange={handleChangePassword}
          />
          <FormFeedback>{intl.formatMessage({ defaultMessage: 'The password must be at least 3 characters' })}</FormFeedback>
        </>
      )}
    </div>
  );
});

ShareModalPasswordProtect.propTypes = {
  requirePassword: PropTypes.bool.isRequired,
  password: PropTypes.string.isRequired,
  passwordError: PropTypes.bool.isRequired,
  handleChangeRequirePassword: PropTypes.func.isRequired,
  handleChangePassword: PropTypes.func.isRequired,
};

export default ShareModalPasswordProtect;
